
export default function (Component) {
  Component.options.__source = "src/views/decision/PavementMaintenancePlanningCustomization/RepairAndMaintenance/OverhaulMaintenanceDic/overhaultypes.vue"
}
